import styled from "styled-components";

export const Section = styled.section`
	padding: 4rem 0;
	background-color: #f9fafb;

	.container {
		max-width: 1200px;
		margin: 0 auto;
		padding: 0 1rem;
	}

	.text-center {
		text-align: center;
		margin-bottom: 3rem;
	}
`;

export const SectionTitle = styled.h2`
	font-size: 2rem;
	font-weight: 700;
	color: #1a1a2e;
	margin-bottom: 0.5rem;

	.highlight {
		color: #642b73;
	}

	@media (min-width: 768px) {
		font-size: 2.5rem;
	}
`;

export const SectionSubtitle = styled.p`
	color: #6b7280;
	max-width: 600px;
	margin: 0.75rem auto 0;
	font-size: 1rem;
	line-height: 1.6;
`;

export const BenefitsGrid = styled.div`
	display: grid;
	grid-template-columns: 1fr;
	gap: 1.5rem;

	@media (min-width: 576px) {
		grid-template-columns: repeat(2, 1fr);
	}

	@media (min-width: 992px) {
		grid-template-columns: repeat(3, 1fr);
	}
`;

export const BenefitCard = styled.div`
	padding: 1.5rem;
	border-radius: 0.75rem;
	background-color: #fff;
	border: 1px solid #e5e7eb;
	transition: box-shadow 0.2s, transform 0.2s;

	&:hover {
		box-shadow: 0 10px 25px rgba(0, 0, 0, 0.08);
		transform: translateY(-2px);
	}

	h3 {
		font-size: 1.1rem;
		font-weight: 600;
		margin-bottom: 0.5rem;
		color: #1a1a2e;
	}

	p {
		font-size: 0.9rem;
		color: #6b7280;
		line-height: 1.5;
	}
`;

export const BenefitIcon = styled.div`
	width: 3rem;
	height: 3rem;
	border-radius: 0.5rem;
	background-color: ${(props) => props.$bgColor};
	color: ${(props) => props.$color};
	display: flex;
	align-items: center;
	justify-content: center;
	margin-bottom: 1rem;
	transition: transform 0.2s;

	${BenefitCard}:hover & {
		transform: scale(1.1);
	}
`;
